// The two events <hj-booking-widget> and its host page exchange about a
// signed-in client's appointments. Mirrored as constants in widget/src/index.ts
// — the widget is a separate bundle and cannot import this file.

/**
 * Widget → host: the client tapped "manage" on the appointments card. Bubbling,
 * composed and CANCELABLE: a host that opens its own manage dialog calls
 * preventDefault(), and a widget whose request nobody claimed asks its assistant
 * instead — so an embed with no handler still answers the tap.
 */
export const MANAGE_APPOINTMENTS_EVENT = 'hj-manage-appointments'

/** Host → widget, dispatched on window: a cancel or move went through, so the card re-reads. */
export const APPOINTMENTS_CHANGED_EVENT = 'hj-appointments-changed'

export interface ManageAppointmentsDetail {
  /** The appointment tapped; absent for "show me all of them". */
  booking_id?: string
}

/** The booking id a manage request names, or null — the detail is untyped page data. */
export function manageRequestBookingId(event: Event): string | null {
  const detail = (event as CustomEvent<ManageAppointmentsDetail | null>).detail
  const id = detail && typeof detail === 'object' ? detail.booking_id : undefined
  return typeof id === 'string' && id ? id : null
}
